import {AppBox, AppContainer, AppPaginator} from "../../../commons/components";
import {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks/app";
import {Outlet, useParams} from "react-router";
import {setPageTitle} from "../../../redux/slices/page-title-slice";
import UserList from "./components/UserList";
import {cleanUpUserList, fetchManageUserList,} from "../../../redux/slices/user/manage-user-list-slice";
import usePagination from "../../../hooks/usePagination";
import useFilter from "../../../hooks/useFilter";

export default function UserManage() {
    const {playerId} = useParams();
    const dispatch = useAppDispatch();
    const {userList} = useAppSelector((state) => state.manageUserList);
    const {page, perPage, pageChange, pageLimitChange} = usePagination();
    const {status, sortOrder, sortBy, searchText} = useFilter();
    useEffect(() => {
        dispatch(setPageTitle("Users"));
    }, []);

    useEffect(() => {
        dispatch(
            fetchManageUserList({
                sort: sortBy,
                sortOrder,
                name: searchText,
                page,
                perPage,
                status
            })
        );
    }, [searchText, page, perPage, status, sortOrder, sortBy]);

    useEffect(() => {
        return () => {
            dispatch(cleanUpUserList());
        };
    }, []);

    return (
        <>
            {playerId ? (
                <Outlet/>
            ) : (
                <AppContainer>
                    <AppBox py="md" flexDirection="column" gap="md">
                        <UserList/>
                        {userList?.pageCount > 1 &&
                            <AppPaginator
                                perPage={userList.perPage}
                                pageCount={userList.pageCount}
                                currentPage={userList.page}
                                pageChange={pageChange}
                                perPageLimitChange={pageLimitChange}/>
                        }
                    </AppBox>
                </AppContainer>
            )}
        </>
    );
}
